import React from 'react';

import LoaderComponent from 'coreComponents/LoaderComponent';
import {suspenseComponent} from 'coreUtils/adapters/lazy';

const fallback = <LoaderComponent />;
const MyAccount = suspenseComponent(() => import('../../pages/my-account'), {fallback});
const Category = suspenseComponent(() => import('../../pages/category'), {fallback});
const ProductDetail = suspenseComponent(() => import('../../pages/product-detail/ProductDetailApi'), {fallback});
const PageNotFound = suspenseComponent(() => import('../../pages/page-not-found'), {fallback});
const CLP = suspenseComponent(() => import('../../pages/clp'), {fallback});

export default [
	{
		component: MyAccount,
		action: '^Account-Show$',
		name: 'myaccount',
	},
	{
		component: ProductDetail,
		action: '^Product-Show$',
		name: 'pdp',
	},
	{
		component: Category,
		action: '^Search-Show$',
		name: 'plp',
	},
	{
		component: CLP,
		action: '^Content-Show$',
		name: 'clp',
	},
	{
		component: PageNotFound,
		action: '^.*$',
		name: '404',
	},
];
